import styled from "styled-components";
import Div from "./div";

enum JustifyContent {
    "space-between" = "space-between",
    "center" = "center",
    "flex-start" = "flex-start",
    "flex-end" = "flex-end",
    "space-evenly" = "space-evenly",
}

interface FlexProps {
    justifyContent: JustifyContent;
    alignItems: "center" | "stretch" | "flex-start" | "flex-end";
    flexDirection: "column" | "row";
    flex: string;
    cursor: "default" | "pointer";
    wrap: "wrap" | "unset" | "wrap-reverse";
}

const Flex = styled(Div)<FlexProps>`
    border: none;
    display: flex;
    justify-content: ${({ justifyContent }) => justifyContent || JustifyContent["space-between"]};
    align-items: ${({ alignItems }) => alignItems || "center"};
    flex-grow: ${({ colWidth }) => colWidth};
    flex-direction: ${({ flexDirection }) => flexDirection || "row"};
    flex: ${({ flex }) => flex};
    flex-wrap: ${({ wrap }) => wrap};
    cursor: ${({ cursor }) => cursor};
`;

export default Flex;
